import { toCamelKeys, toSnakeKeys } from 'utils/convert.util';
import { store as notificatonStore } from 'react-notifications-component';
import { store } from 'index';
import { signoutRequest } from 'redux/actions/authActions';

require('dotenv').config();

export async function handleResponse(response) {
  const jsonData = response.json();
  if (response.ok) return jsonData;
  if (response.status === 400) {
    // So, a server-side validation error occurred.
    // Server side validation returns a string error message,
    // so parse as text instead of json.
    const error = await response.text();
    throw new Error(error);
  }
  throw new Error('Network response was not ok.');
}

export async function handleTokenResponse(response) {
  if (response.ok) return response.text();
  throw new Error('Token response was not ok.');
}

// In a real app, would likely call an error logging service.
export function handleError(error) {
  // eslint-disable-next-line no-console
  console.error(`API call failed. ${error}`);
  throw error;
}

export function getHeaderInfo() {
  const userInfo = store.getState().user;
  const token = userInfo.jwt;
  const headerInfo = {
    'Content-Type': 'application/json',
    Accept: 'application/vnd.api+json',
    'ngrok-skip-browser-warning': 'true', // Bypass ngrok's browser interstitial so fetch gets JSON, not HTML (looks like a CORS failure otherwise)
    Authorization: `Bearer ${token}`,
  };

  return headerInfo;
}

export function setHeaderInfo(newToken) {
  localStorage.setItem('jwt', newToken);
}

function parseJSON(response) {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.text();
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  if (response.status === 401) {
    store.dispatch(signoutRequest());
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

export function getGroupOrderURL(groupOrderUuid) {
  console.log('debug.................');
  console.log(
    `REACT_APP_GROUP_ORDER_APP_URL: ${process.env.REACT_APP_GROUP_ORDER_APP_URL}`,
  );
  return `${process.env.REACT_APP_GROUP_ORDER_APP_URL}${groupOrderUuid}`;
}

export function fetchAPI(
  url,
  method = 'GET',
  payload = null,
  params = null,
  customHeaders = null,
  suppressNotification = false,
) {
  const requestUrl = `${process.env.REACT_APP_API_URL}/${url}`;
  let finalUrl = requestUrl;
  if (params && method === 'GET') {
    const urlParams = new URLSearchParams(params);

    // Check if there's already a query string in the base URL
    const separator = requestUrl.includes('?') ? '&' : '?';
    finalUrl = `${requestUrl}${separator}${urlParams.toString()}`;
  }

  const options = { method };
  const headers = {
    ...getHeaderInfo(),
    ...customHeaders, // Allow overriding headers
  };

  if (payload) {
    if (payload instanceof FormData) {
      options.body = payload;
      delete headers['Content-Type'];
    } else {
      options.body = JSON.stringify(toSnakeKeys(payload));
    }
  }

  console.log('Making API call to:', finalUrl); // Debugging the final URL

  return fetch(finalUrl, {
    ...options,
    headers,
  })
    .then(checkStatus)
    .then(parseJSON)
    .then(resp => {
      return toCamelKeys(resp ? JSON.parse(resp) : {});
    })
    .catch(err => {
      if (err.response && !suppressNotification) {
        // Error responses aren't guaranteed to have a JSON (or any) body -
        // e.g. a 401 with an empty body on bad sign-in credentials. Without
        // this catch, that .json() rejection went unhandled, which is what
        // was surfacing as an uncaught "Unexpected end of JSON input" error
        // any time a request failed with a non-JSON error body.
        err.response
          .json()
          .then(response => {
            if (typeof response?.error == 'string') {
              notificatonStore.addNotification({
                title: 'Error',
                message: response?.error,
                type: 'danger',
                insert: 'top',
                container: 'top-right',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                  duration: 5000,
                  onScreen: true,
                },
              });
            }
          })
          .catch(() => {
            // response body wasn't JSON (or was empty) - nothing to show.
          });
      } else {
        // show alert
      }
      throw err;
    });
}

export function fetchFile(url, name, method = 'GET') {
  const requestUrl = `${process.env.REACT_APP_API_URL}/${url}`;
  const options = { method };
  const headers = getHeaderInfo();

  return fetch(requestUrl, {
    ...options,
    headers,
  })
    .then(res => {
      return res.blob();
    })
    .then(data => {
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(data);
      a.download = name;
      a.click();
    })
    .catch(err => {
      throw err;
    });
}
